import { axiosInstance } from '@/apis/base'
import config from '../../config.json'

/**
 * Returns an array of all active topics.
 *
 * @return {Promise<AxiosResponse<any>>}
 */
export function getAllTopics() {
  return axiosInstance
    .get(`${config.apiUrl}/topics/get_common_list`)
    .then(({ data }) => data.list)
}
